import React, { forwardRef, useMemo } from 'react'
import Text from '../Text'
import { BreadcrumbsProps } from './props'
import { Breadcrumb, StyledBreadcrumbs } from './styles'

const Breadcrumbs = forwardRef<HTMLOListElement, BreadcrumbsProps>(
    ({ links, separator = '/' }, ref) => {
        const breadcrumbs = useMemo(
            () =>
                links.map((link, key) => {
                    const { label, onClick } = link
                    const lastItem = key === links.length - 1

                    return (
                        <React.Fragment key={key}>
                            <Breadcrumb last={lastItem} onClick={onClick}>
                                {lastItem ? (
                                    label
                                ) : (
                                    <Text
                                        primary
                                        css={{
                                            cursor: 'pointer',
                                        }}
                                    >
                                        {label}
                                    </Text>
                                )}
                            </Breadcrumb>
                            {!lastItem && separator}
                        </React.Fragment>
                    )
                }),
            [links, separator]
        )

        return <StyledBreadcrumbs ref={ref}>{breadcrumbs}</StyledBreadcrumbs>
    }
)

Breadcrumbs.displayName = 'Breadcrumbs'

export default Breadcrumbs

export { StyledBreadcrumbs }
